import Client from './Clients/AxiosClient'
const resource = '/paymentMethod'

export default {
  get() {
    return Client.get(`${resource}`)
  },
  getDeleted() {
    return Client.get(`${resource}?status=false`)
  },
  getTest(id) {
    return Client.get(`${resource}/${id}`)
  },
  create(payload) {
    return Client.post(`${resource}`, payload)
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload)
  },
  delete(id) {
    return Client.patch(`${resource}/status/${id}`, { status: false })
  },
  reactivate(id) {
    return Client.patch(`${resource}/status/${id}`, { status: true })
  },
}
